<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表附列资料（二）<br />(本期进项税额明细表)</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody class="read-mode">
          <tr>
            <td colspan="5" class="td_align td_height font-w">一、申报抵扣的进项税额</td>
          </tr>
          <tr>
            <td class="td_align td_height font-w" style="width: 400px">项目</td>
            <td class="td_align font-w" style="width: 150px">栏次</td>
            <td class="td_align font-w" style="width: 150px">份数</td>
            <td class="td_align font-w" style="width: 150px">金额</td>
            <td class="td_align font-w" style="width: 150px">税额</td>
          </tr>
          <tr>
            <td>(一)认证相符的增值税专用发票</td>
            <td class="td_height td_align">1=2+3</td>
            <td>{{ parseFloatNum(data.v1x1.value) }}</td>
            <td>{{ parseFloatNum(data.v1x2.value) }}</td>
            <td>{{ parseFloatNum(data.v1x3.value) }}</td>
          </tr>
          <tr>
            <td class="indent_2em">其中：&nbsp;本期认证相符且本期申报抵扣</td>
            <td class="td_height td_align">2</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_6em">前期认证相符且本期申报抵扣</td>
            <td class="td_height td_align">3</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td>(二)其他扣税凭证</td>
            <td class="td_height td_align">4=5+6+7+8</td>
            <td>{{ parseFloatNum(data.v4x1.value) }}</td>
            <td>{{ parseFloatNum(data.v4x2.value) }}</td>
            <td>{{ parseFloatNum(data.v4x3.value) }}</td>
          </tr>
          <tr>
            <td class="indent_2em">其中：&nbsp;海关进口增值税专用缴款书</td>
            <td class="td_height td_align">5</td>
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">农产品收购发票或者销售发票</td>
            <td class="td_height td_align">6</td>
            <td>
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">代扣代缴税收缴款凭证</td>
            <td class="td_height td_align">7</td>
            <td>
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">加计扣除农产品进项税额</td>
            <td class="td_height td_align">8a</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">其他</td>
            <td class="td_height td_align">8b</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v37x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v37x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v37x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td>（三）本期用于购建不动产的扣税凭证</td>
            <td class="td_height td_align">9</td>
            <td>
              <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td>（四）本期用于抵扣的旅客运输服务扣税凭证</td>
            <td class="td_height td_align">10</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v10x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v10x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v10x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td>（五）外贸企业进项税额抵扣证明</td>
            <td class="td_height td_align">11</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td>当期申报抵扣进项税额合计</td>
            <td class="td_height td_align">12=1+4+11</td>
            <td>{{ parseFloatNum(data.v12x1.value) }}</td>
            <td>{{ parseFloatNum(data.v12x2.value) }}</td>
            <td>{{ parseFloatNum(data.v12x3.value) }}</td>
          </tr>
          <tr>
            <td colspan="5" class="td_height td_align font-w">二、进项税额转出额</td>
          </tr>
          <tr>
            <td class="td_align td_height font-w">项目</td>
            <td class="td_align font-w">栏次</td>
            <td colspan="3" class="td_align font-w">税额</td>
          </tr>
          <tr>
            <td class="td_height">本期进项税转出额</td>
            <td class="td_height td_align">13=14至23之和</td>
            <td colspan="3">{{ parseFloatNum(data.v13x1.value) }}</td>
          </tr>
          <tr>
            <td class="indent_2em">其中：免税项目用</td>
            <td class="td_height td_align">14</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">集体福利、个人消费</td>
            <td class="td_height td_align">15</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">非正常损失</td>
            <td class="td_height td_align">16</td>
            <td colspan="3">
              <!-- 考题 -->
              <taxQue :data="data.v16x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v16x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_6em">简易计税方法征税项目用</td>
            <td class="td_height td_align">17</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v17x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">免抵退税办法不得抵扣的进项税额</td>
            <td class="td_height td_align">18</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">纳税检查调减进项税额</td>
            <td class="td_height td_align">19</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">红字专用发票信息表注明的进项税额</td>
            <td class="td_height td_align">20</td>
            <td colspan="3">
              <!-- 考题 -->
              <taxQue :data="data.v20x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v20x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v20x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v20x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td class="indent_6em">上期留抵税额抵减欠税</td>
            <td class="td_height td_align">21</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">上期留抵税额退税</td>
            <td class="td_height td_align">22</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">异常凭证转出进项税额</td>
            <td class="td_height td_align">23a</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">其他应作进项税额转出的情形</td>
            <td class="td_height td_align">23b</td>
            <td colspan="3">
              <el-input-number v-model.trim="data.v38x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="5" class="td_align td_height font-w">三、待抵扣进项税额</td>
          </tr>
          <tr>
            <td class="td_align td_height font-w">项目</td>
            <td class="td_align font-w">栏次</td>
            <td class="td_align font-w">份数</td>
            <td class="td_align font-w">金额</td>
            <td class="td_align font-w">税额</td>
          </tr>
          <tr>
            <td>(一)认证相符的增值税专用发票</td>
            <td class="td_height td_align">24</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td class="indent_2em">期初已认证相符但未申报抵扣</td>
            <td class="td_height td_align">25</td>
            <td>
              <el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v25x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_2em">本期认证相符且本期未申报抵扣</td>
            <td class="td_height td_align">26</td>
            <td>
              <el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v26x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_2em">期末已认证相符但未申报抵扣</td>
            <td class="td_height td_align">27</td>
            <td>
              <el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v27x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_4em">其中：按照税法规定不允许抵扣</td>
            <td class="td_height td_align">28</td>
            <td>
              <el-input-number v-model.trim="data.v28x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v28x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v28x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td>(二)其他扣税凭证</td>
            <td class="td_height td_align">29=30至33之和</td>
            <td>{{ parseFloatNum(data.v29x1.value) }}</td>
            <td>{{ parseFloatNum(data.v29x2.value) }}</td>
            <td>{{ parseFloatNum(data.v29x3.value) }}</td>
          </tr>
          <tr>
            <td class="indent_2em">其中：&nbsp;海关进口增值税专用缴款书</td>
            <td class="td_height td_align">30</td>
            <td>
              <el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v30x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">农产品收购发票或者销售发票</td>
            <td class="td_height td_align">31</td>
            <td>
              <el-input-number v-model.trim="data.v31x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v31x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v31x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">代扣代缴税收缴款凭证</td>
            <td class="td_height td_align">32</td>
            <td>
              <el-input-number v-model.trim="data.v32x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v32x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em">其他</td>
            <td class="td_height td_align">33</td>
            <td>
              <el-input-number v-model.trim="data.v33x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v33x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v33x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td class="indent_6em"></td>
            <td class="td_height td_align">34</td>
            <td>
              <el-input-number v-model.trim="data.v34x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v34x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v34x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="5" class="td_align td_height font-w">四、其他</td>
          </tr>
          <tr>
            <td class="td_align td_height font-w">项目</td>
            <td class="td_align font-w">栏次</td>
            <td class="td_align font-w">份数</td>
            <td class="td_align font-w">金额</td>
            <td class="td_align font-w">税额</td>
          </tr>
          <tr>
            <td>本期认证相符的增值税专用发票</td>
            <td class="td_height td_align">35</td>
            <td>{{ parseFloatNum(data.v35x1.value) }}</td>
            <td>{{ parseFloatNum(data.v35x2.value) }}</td>
            <td>{{ parseFloatNum(data.v35x3.value) }}</td>
          </tr>
          <tr>
            <td>代扣代缴税额</td>
            <td class="td_height td_align">36</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v36x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0">
      <span style="font-size: 20px; color: red; margin-right: 5px; font-family: monospace">★</span>
      <span>温馨提示：销售额不包括销项税额（或应纳税额），纳税人采用销售额和销项税额合并定价方法的，按照下列公式计算销售额：销售额＝含税销售额÷（1+税率或征收率）</span>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 3列
        for (let column = 1; column <= 3; column++) {
          // 1=2+3
          data.value[`v1x${column}`].value = new Big(data.value[`v2x${column}`].value).plus(data.value[`v3x${column}`].value).round(2).toNumber();
          // 4=5+6+7+8 8a为8 8b为37
          data.value[`v4x${column}`].value = new Big(data.value[`v5x${column}`].value)
            .plus(data.value[`v6x${column}`].value)
            .plus(data.value[`v7x${column}`].value)
            .plus(data.value[`v8x${column}`].value)
            .plus(data.value[`v37x${column}`].value)
            .round(2)
            .toNumber();
          // 12=1+4+11
          data.value[`v12x${column}`].value = new Big(data.value[`v1x${column}`].value).plus(data.value[`v4x${column}`].value).plus(data.value[`v11x${column}`].value).round(2).toNumber();
          // 13=14至23之和
          data.value[`v13x${column}`].value = new Big(data.value[`v14x${column}`].value)
            .plus(data.value[`v15x${column}`].value)
            .plus(data.value[`v16x${column}`].value)
            .plus(data.value[`v17x${column}`].value)
            .plus(data.value[`v18x${column}`].value)
            .plus(data.value[`v19x${column}`].value)
            .plus(data.value[`v20x${column}`].value)
            .plus(data.value[`v21x${column}`].value)
            .plus(data.value[`v22x${column}`].value)
            .round(2)
            .toNumber();
          // 29=30至33之和
          data.value[`v29x${column}`].value = new Big(data.value[`v30x${column}`].value)
            .plus(data.value[`v31x${column}`].value)
            .plus(data.value[`v32x${column}`].value)
            .plus(data.value[`v33x${column}`].value)
            .round(2)
            .toNumber();
          // 35=2+26
          data.value[`v35x${column}`].value = new Big(data.value[`v2x${column}`].value).plus(data.value[`v26x${column}`].value).round(2).toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  max-width: 1200px !important;
}
</style>

<script>
const tableHtml = `
<table>
  <tbody class="read-mode">
    <tr>
      <td colspan="5" class="td_align td_height font-w">一、申报抵扣的进项税额</td>
    </tr>
    <tr>
      <td class="td_align td_height font-w" style="width: 400px">项目</td>
      <td class="td_align font-w" style="width: 150px">栏次</td>
      <td class="td_align font-w" style="width: 150px">份数</td>
      <td class="td_align font-w" style="width: 150px">金额</td>
      <td class="td_align font-w" style="width: 150px">税额</td>
    </tr>
    <tr>
      <td>(一)认证相符的增值税专用发票</td>
      <td class="td_height td_align">1=2+3</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">其中：&nbsp;本期认证相符且本期申报抵扣</td>
      <td class="td_height td_align">2</td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">前期认证相符且本期申报抵扣</td>
      <td class="td_height td_align">3</td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>(二)其他扣税凭证</td>
      <td class="td_height td_align">4=5+6+7+8</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">其中：&nbsp;海关进口增值税专用缴款书</td>
      <td class="td_height td_align">5</td>
      <td>
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">农产品收购发票或者销售发票</td>
      <td class="td_height td_align">6</td>
      <td>
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">代扣代缴税收缴款凭证</td>
      <td class="td_height td_align">7</td>
      <td>
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_7_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">加计扣除农产品进项税额</td>
      <td class="td_height td_align">8a</td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">其他</td>
      <td class="td_height td_align">8b</td>
      <td>
        <div validate="data_9_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>（三）本期用于购建不动产的扣税凭证</td>
      <td class="td_height td_align">9</td>
      <td>
        <div validate="data_10_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>（四）本期用于抵扣的旅客运输服务扣税凭证</td>
      <td class="td_height td_align">10</td>
      <td>
        <div validate="data_11_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>（五）外贸企业进项税额抵扣证明</td>
      <td class="td_height td_align">11</td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_12_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>当期申报抵扣进项税额合计</td>
      <td class="td_height td_align">12=1+4+11</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="5" class="td_height td_align font-w">二、进项税额转出额</td>
    </tr>
    <tr>
      <td class="td_align td_height font-w">项目</td>
      <td class="td_align font-w">栏次</td>
      <td colspan="3" class="td_align font-w">税额</td>
    </tr>
    <tr>
      <td class="td_height">本期进项税转出额</td>
      <td class="td_height td_align">13=14至23之和</td>
      <td colspan="3">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">其中：免税项目用</td>
      <td class="td_height td_align">14</td>
      <td colspan="3">
        <div validate="data_15_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">集体福利、个人消费</td>
      <td class="td_height td_align">15</td>
      <td colspan="3">
        <div validate="data_16_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">非正常损失</td>
      <td class="td_height td_align">16</td>
      <td colspan="3">
        <div validate="data_17_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">简易计税方法征税项目用</td>
      <td class="td_height td_align">17</td>
      <td colspan="3">
        <div validate="data_18_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">免抵退税办法不得抵扣的进项税额</td>
      <td class="td_height td_align">18</td>
      <td colspan="3">
        <div validate="data_19_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">纳税检查调减进项税额</td>
      <td class="td_height td_align">19</td>
      <td colspan="3">
        <div validate="data_20_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">红字专用发票信息表注明的进项税额</td>
      <td class="td_height td_align">20</td>
      <td colspan="3">
        <div validate="data_21_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">上期留抵税额抵减欠税</td>
      <td class="td_height td_align">21</td>
      <td colspan="3">
        <div validate="data_22_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">上期留抵税额退税</td>
      <td class="td_height td_align">22</td>
      <td colspan="3">
        <div validate="data_23_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">异常凭证转出进项税额</td>
      <td class="td_height td_align">23a</td>
      <td colspan="3">
        <div validate="data_24_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">其他应作进项税额转出的情形</td>
      <td class="td_height td_align">23b</td>
      <td colspan="3">
        <div validate="data_24_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="5" class="td_align td_height font-w">三、待抵扣进项税额</td>
    </tr>
    <tr>
      <td class="td_align td_height font-w">项目</td>
      <td class="td_align font-w">栏次</td>
      <td class="td_align font-w">份数</td>
      <td class="td_align font-w">金额</td>
      <td class="td_align font-w">税额</td>
    </tr>
    <tr>
      <td>(一)认证相符的增值税专用发票</td>
      <td class="td_height td_align">24</td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td class="indent_2em">期初已认证相符但未申报抵扣</td>
      <td class="td_height td_align">25</td>
      <td>
        <div validate="data_25_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_25_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_25_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">本期认证相符且本期未申报抵扣</td>
      <td class="td_height td_align">26</td>
      <td>
        <div validate="data_26_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_26_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_26_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">期末已认证相符但未申报抵扣</td>
      <td class="td_height td_align">27</td>
      <td>
        <div validate="data_27_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_27_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_27_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_4em">其中：按照税法规定不允许抵扣</td>
      <td class="td_height td_align">28</td>
      <td>
        <div validate="data_28_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_28_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_28_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td>(二)其他扣税凭证</td>
      <td class="td_height td_align">29=30至33之和</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="indent_2em">其中：&nbsp;海关进口增值税专用缴款书</td>
      <td class="td_height td_align">30</td>
      <td>
        <div validate="data_30_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_30_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_30_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">农产品收购发票或者销售发票</td>
      <td class="td_height td_align">31</td>
      <td>
        <div validate="data_31_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_31_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_31_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">代扣代缴税收缴款凭证</td>
      <td class="td_height td_align">32</td>
      <td>
        <div validate="data_32_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_32_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em">其他</td>
      <td class="td_height td_align">33</td>
      <td>
        <div validate="data_33_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_33_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_33_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td class="indent_6em"></td>
      <td class="td_height td_align">34</td>
      <td>
        <div validate="data_34_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_34_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_34_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="5" class="td_align td_height font-w">四、其他</td>
    </tr>
    <tr>
      <td class="td_align td_height font-w">项目</td>
      <td class="td_align font-w">栏次</td>
      <td class="td_align font-w">份数</td>
      <td class="td_align font-w">金额</td>
      <td class="td_align font-w">税额</td>
    </tr>
    <tr>
      <td>本期认证相符的增值税专用发票</td>
      <td class="td_height td_align">35</td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>代扣代缴税额</td>
      <td class="td_height td_align">36</td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_36_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
